import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { BiEdit } from "react-icons/bi";
import { IoPlayForwardCircle } from "react-icons/io5";
import { FcCalendar } from "react-icons/fc";
import moment from "moment";
import { DatePicker } from "antd";
import { useDispatch, useSelector } from "react-redux";
import {
  AppDispatch,
  dynamicSet,
  getReadingList,
  getSubject,
  updateNextScreeningDateRequest,
  updateSubject,
  updateSubjectRequest,
  useDynamicSelector,
} from "@src/redux";
import dayjs from "dayjs";
import { useParams } from "react-router-dom";
import { useCheckPageComponentAccess } from "@src/hooks/index";

type Props = {};

const DetailsHeaderFirstRow = (props: Props) => {
  const { t } = useTranslation();
  const { id } = useParams();
  const dispatch = useDispatch<AppDispatch>();
  const { result: readingList } = useSelector(getReadingList);
  const { result: subject } = useSelector(getSubject);
  const { readingIndex } = useDynamicSelector("get_reading_index");

  const disablePastDates = (date: dayjs.Dayjs) => {
    return date && date.isBefore(dayjs().startOf("day"));
  };
  const handleChange = (date: any) => {
    dispatch(
      updateNextScreeningDateRequest({
        id: id || "",
        data: { nextReadingDate: date },
      })
    );
  };

  // const handle_click = () => {
  //   dispatch(
  //     dynamicSet("get_reading_index", {
  //       reading_index: Number(reading_list?.items?.length) - 1,
  //     })
  //   );
  //   dispatch(
  //     dynamicSet("get_reading_details", {
  //       reading: reading_list?.items?.[reading_list?.items?.length - 1],
  //     })
  //   );
  // };

  const handleClick = () => {
    dispatch(
      dynamicSet("get_reading_index", {
        readingIndex: 0, 
      })
    );
    dispatch(
      dynamicSet("get_reading_details", {
        reading: readingList?.items?.[0], 
      })
    );
  };

  const canEditDate = useCheckPageComponentAccess("edit_next_screening");

  return (
    <div className="details_first_row">
      <div className="details_last_screening_container" id="latest_screening">
        <span className="details_last_screening_text">
          {t("latest_screening")}
        </span>
      </div>
      <div className="details_screening_date_box">
        <div className="details_screening_date_container">
          {/* <span className="details_last_screening_date">
            {reading_list?.items && reading_list?.items?.length > 0
              ? moment(
                  reading_list.items[reading_list.items.length - 1]?.datetime
                ).format("DD-MMM-YYYY")
              : "-"}
          </span> */}

          <span className="details_last_screening_date">
            {readingList?.items?.length
              ? moment(readingList.items[0]?.datetime).format("DD-MMM-YYYY")
              : "-"}
          </span>
        </div>
        <div className="details_screening_date_container">
          {/* <span className="details_last_screening_date">
            {reading_list?.items && reading_list?.items?.length > 0
              ? moment(
                  reading_list?.items[reading_list?.items?.length - 1]?.datetime
                ).format("hh:mm A")
              : "-"}
          </span> */}

          <span className="details_last_screening_date">
            {readingList?.items && readingList?.items?.length > 0
              ? moment(readingList?.items[0]?.datetime).format("hh:mm A")
              : "-"}
          </span>
        </div>
        <div className="details_screening_icon_container">
          <IoPlayForwardCircle
            className="details_next_date_icon"
            onClick={handleClick}
            style={{
              // color:
              //   Number(reading_index) ===
              //   Number(Number(reading_list?.items?.length || 0) - 1)
              //     ? ""
              //     : "white",
              color: Number(readingIndex) === 0 ? "" : "white",
            }}
          />
        </div>
      </div>
      <div className="details_screening_date_box next_details_screening_date_box ">
        <div className="details_last_screening_container" id="next_screening">
          <span className="details_last_screening_text">
            {t("next_screening")}
          </span>
        </div>
        <div className="details_screening_icon_container">
          <div style={{ position: "absolute", zIndex: 9 }}>
            <DatePicker
              variant="borderless"
              onChange={handleChange}
              value={
                subject?.nextReadingDate
                  ? dayjs(subject?.nextReadingDate)
                  : null
              }
              format={"DD-MMM-YYYY"}
              suffixIcon={<BiEdit color="white" size={18} 
              style={{
                opacity: canEditDate ? 1 : 0.5,
                cursor: canEditDate ? "pointer" : "not-allowed",
                color:canEditDate ? "white" : "#ccc"
              }}/>}
              readOnly
              className="user-subject-date-picker"
              allowClear={false}
              disabledDate={(date: any) => disablePastDates(date)}
              defaultPickerValue={dayjs()}
              disabled={!canEditDate}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default DetailsHeaderFirstRow;
